<template>
<div class="chapter">
<div class="inner_page">
<div class="contents">
<a id="TOC1"><p class="contentsHead">CONTENTS</p>
</a><p class="contentsEntry"><a id="TOC1"></a><span href="#/e9780545908986_title001#tp01" title="Link target outside of Sample">TITLE PAGE</span></p>
<p class="contentsEntry"><span href="#/e9780545908986_ded001#ded01" title="Link target outside of Sample">DEDICATION</span></p>
<p class="contentsEntry"><a href="#/e9780545908986_ch001#ch1">CHAPTER 1</a></p>
<p class="contentsEntry"><span href="#/e9780545908986_ch002#ch2" title="Link target outside of Sample">CHAPTER 2</span></p>
<p class="contentsEntry"><span href="#/e9780545908986_ch003#ch3" title="Link target outside of Sample">CHAPTER 3</span></p>
<p class="contentsEntry"><span href="#/e9780545908986_ch004#ch4" title="Link target outside of Sample">CHAPTER 4</span></p>
<p class="contentsEntry"><span href="#/e9780545908986_ch005#ch5" title="Link target outside of Sample">CHAPTER 5</span></p>
<p class="contentsEntry"><span href="#/e9780545908986_ch006#ch6" title="Link target outside of Sample">CHAPTER 6</span></p>
<p class="contentsEntry"><span href="#/e9780545908986_ch007#ch7" title="Link target outside of Sample">CHAPTER 7</span></p>
<p class="contentsEntry"><span href="#/e9780545908986_ch008#ch8" title="Link target outside of Sample">CHAPTER 8</span></p>
<p class="contentsEntry"><span href="#/e9780545908986_ch009#ch9" title="Link target outside of Sample">CHAPTER 9</span></p>
<p class="contentsEntry"><span href="#/e9780545908986_ch010#ch10" title="Link target outside of Sample">CHAPTER 10</span></p>
<p class="contentsEntry"><span href="#/e9780545908986_ch011#ch11" title="Link target outside of Sample">CHAPTER 11</span></p>
<p class="contentsEntry"><span href="#/e9780545908986_ch012#ch12" title="Link target outside of Sample">CHAPTER 12</span></p>
<p class="contentsEntry"><span href="#/e9780545908986_ata001#ata01" title="Link target outside of Sample">ABOUT THE AUTHOR</span></p>
<p class="contentsEntry"><span href="#/e9780545908986_bm001#bm1" title="Link target outside of Sample">ALSO AVAILABLE</span></p>
<p class="contentsEntry"><span href="#/e9780545908986_copy001#cop01" title="Link target outside of Sample">COPYRIGHT</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545908986_toc001.vue?ccda39fe